import Information from "./information";
export default Information;